import { render } from "./positionCard.vue?vue&type=template&id=abd5c8c6&scoped=true"
import script from "./positionCard.vue?vue&type=script&lang=js"
export * from "./positionCard.vue?vue&type=script&lang=js"

import "./positionCard.vue?vue&type=style&index=0&id=abd5c8c6&scoped=true&lang=less"

import exportComponent from "/root/.jenkins/workspace/embeddedJobWebProd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abd5c8c6"]])

export default __exports__